import Component from './component';

Component.defaultProps = {
    layoutContainerProps: null,
    descriptionProps: null,
    form: null,
};
export default Component;
